module.exports = __webpack_public_path__ + "static/media/logo.56f19bb5.png";